import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import DialogList from 'src/dialogs';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { AnyObject } from 'final-form';

interface IGenerateInvoiceListingDialogProps {
    dialogName: string;
    handleSubmit?: (payload: AnyObject) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    offices?: Array<{value: number | string, label: string}>;
}

const GenerateInvoiceListingDialog = (props: IGenerateInvoiceListingDialogProps) => {
    const [offices, setOffices] = useState<Array<{value: number | string, label: string}>>(undefined);
    const { register, handleSubmit, errors } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (Array.isArray(props?.offices) && props.offices.length > 0) {
            const officesWithAll = props.offices;
            officesWithAll.unshift({ value: '0', label: 'ALL'});
            setOffices(officesWithAll);
        }
    }, [props?.offices]);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const onSubmit = (data: AnyObject) => {
        const formData = data.generateListing;
        formData.office = offices.find(o => o.value === formData.office).label;

        if (formData) {
            props.handleSubmit(formData);
        }
    };

    return (
        <Dialog title="Generate Invoice Listing" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                type={'date'}
                                label={'Begin Date:'}
                                name={'generateListing.beginDate'}
                                register={register}
                            />
                            <RHFInputBox
                                type={'date'}
                                label={'End Date:'}
                                name={'generateListing.endDate'}
                                register={register}
                            />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                label={'Client #:'}
                                name={'generateListing.clientNumber'}
                                register={register}
                            />
                            <RHFInputBox
                                label={'Project:'}
                                name={'generateListing.projectNumber'}
                                register={register}
                            />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                label={'Subcode:'}
                                name={'generateListing.subcode'}
                                register={register}
                            />
                            <RHFInputBox
                                label={'Account #:'}
                                name={'generateListing.accountNumber'}
                                register={register}
                            />
                        </div>
                        {offices && <RHFSelect
                            label="Billing Office"
                            labelOnLeft={true}
                            labelStyle={{whiteSpace: 'nowrap', marginRight: '11rem'}}
                            name={`generateListing.office`}
                            options={!!props?.offices && props?.offices?.length > 0 ? props.offices : [
                                { value: '1', label: 'ALL' },
                                { value: '2', label: 'OK' },
                                { value: '3', label: 'TX' },
                                { value: '4', label: 'IH' }
                            ]}
                            register={register}
                            errors={errors}
                            style={{ width: '50%' }}
                            bodyStyle={{ width: '100%' }}
                        />}
                    </div>
                    <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ whiteSpace: 'nowrap', width: '58%', marginRight: '1rem' }}
                            text={'Generate Listing'}
                            type={'submit'}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default GenerateInvoiceListingDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/GenerateInvoiceListingDialog.tsx